import React from 'react';
import { useClientVersionCheck } from '../hooks/useClientVersionCheck';

const ClientUpdateBanner: React.FC = () => {
  const { updateAvailable, reloadApp, dismissUpdate } = useClientVersionCheck();

  if (!updateAvailable) return null;

  return (
    <div
      role="status"
      style={{
        position: 'fixed',
        bottom: 16,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 2000,
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '10px 14px',
        borderRadius: 10,
        background: '#1f2937',
        color: '#fff',
        boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
        maxWidth: 'min(92vw, 520px)',
      }}
    >
      <span style={{ fontSize: 14 }}>A newer version of SkipScreen is available.</span>
      <button
        type="button"
        onClick={reloadApp}
        style={{
          border: 'none',
          borderRadius: 8,
          background: '#2ecc71',
          color: '#fff',
          padding: '6px 12px',
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        Refresh
      </button>
      <button
        type="button"
        onClick={dismissUpdate}
        aria-label="Dismiss update notice"
        style={{
          border: 'none',
          background: 'transparent',
          color: '#cbd5e1',
          cursor: 'pointer',
          fontSize: 18,
          lineHeight: 1,
        }}
      >
        ×
      </button>
    </div>
  );
};

export default ClientUpdateBanner;
